import type { TurnstileInvalidationReason } from "@/lib/turnstile"

export const TURNSTILE_FRAME_INIT = "boundless-turnstile:init" as const

export type TurnstileFrameInitMessage = {
  type: typeof TURNSTILE_FRAME_INIT
  sessionId: string
}

export type TurnstileFrameCommand = {
  type: "reset"
}

export type TurnstileFrameMessage =
  | { type: "ready" }
  | { type: "token"; token: string }
  | { type: "invalidated"; reason: TurnstileInvalidationReason }
  | { type: "fatal"; message: string }
  | { type: "resize"; height: number }

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

export function isTurnstileFrameInitMessage(
  value: unknown,
): value is TurnstileFrameInitMessage {
  return (
    isRecord(value) &&
    value.type === TURNSTILE_FRAME_INIT &&
    typeof value.sessionId === "string" &&
    value.sessionId.length > 0
  )
}

export function isTurnstileFrameCommand(
  value: unknown,
): value is TurnstileFrameCommand {
  return isRecord(value) && value.type === "reset"
}

export function isTurnstileFrameMessage(
  value: unknown,
): value is TurnstileFrameMessage {
  if (!isRecord(value) || typeof value.type !== "string") return false

  switch (value.type) {
    case "ready":
      return true
    case "token":
      return typeof value.token === "string" && value.token.length > 0
    case "invalidated":
      return (
        value.reason === "error" ||
        value.reason === "expired" ||
        value.reason === "timeout"
      )
    case "fatal":
      return typeof value.message === "string" && value.message.length > 0
    case "resize":
      return typeof value.height === "number" && Number.isFinite(value.height)
    default:
      return false
  }
}
